import { OpportunityInactivityReason } from '@inversor-hub/types';

export const OPPORTUNITY_INACTIVITY_REASON_LABELS: Record<OpportunityInactivityReason, string> = {
  ALREADY_SOLD: 'Ya vendida',
  NO_LONGER_AVAILABLE: 'Ya no disponible',
  PRICE_CHANGED: 'Cambio de precio',
  PROPERTY_ISSUES: 'Problemas con la propiedad',
  MARKET_CONDITIONS: 'Condiciones del mercado',
  OTHER: 'Otro',
};

export const PROFILE_COMPLETION_MESSAGE =
  '💡 Por favor, recuerda rellenar todos tus datos personales para que el PSI pueda contactarte y evaluar mejor tu solicitud. Puedes rellenar tus datos accediendo desde tu perfil o';

export const PROFILE_LINK_TEXT = 'haciendo click aquí';

/**
 * Calculate remaining time until 24 hours have passed since the given date
 * @param selectedAt - ISO string date representing when interest was marked as selected
 * @returns Object with remaining time details or null if expired
 */
export const calculateRemainingSelectedTime = (selectedAt: string) => {
  const now = new Date();
  const updatedDate = new Date(selectedAt);
  const expirationDate = new Date(updatedDate.getTime() + 24 * 60 * 60 * 1000); // 24 hours
  const remainingMs = expirationDate.getTime() - now.getTime();

  if (remainingMs <= 0) {
    return null;
  }

  const remainingHours = Math.floor(remainingMs / (1000 * 60 * 60));
  const remainingMinutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));

  return {
    hours: remainingHours,
    minutes: remainingMinutes,
    text: remainingHours > 0 ? `${remainingHours}h ${remainingMinutes}m` : `${remainingMinutes}m`,
  };
};
